import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductSuggestionResponse, Suggestion } from '../../_models/product-suggestion-res.model';
import { RerunTask } from '../rerun-task/rerun-task';
import { ProductTable } from '../product-table/product-table';
import { Waiting } from '../waiting/waiting';
import { UploadDocument } from '../upload-document/upload-document';
import { DocumentService } from '../../_services/document.service';
import { DocumentTypeEnum } from '../../_enums/document-type.enum';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-product-suggestion',
  imports: [
    TranslatePipe,
    ProductTable,
    MatButton,
    Waiting,
    RerunTask,
    UploadDocument,
    MatTooltipModule,
  ],
  templateUrl: './product-suggestion.html',
  styleUrl: './product-suggestion.scss',
})
export class ProductSuggestion implements OnInit, OnChanges {
  @ViewChild('uploadDocument') uploadDocument!: UploadDocument;
  @Input() productSuggestionError: boolean = false;
  @Input() suggestedProducts: ProductSuggestionResponse | null = null;
  @Input() isProductSuggestionInProgress = false;

  // Kept in the workflow, the decision step uses it.
  @Input() selectedProducts: Suggestion[] = [];

  @Output() rerun = new EventEmitter<void>();
  @Output() selectedProductsChange = new EventEmitter<Suggestion[]>();

  public actionPlanExists = false;
  public DocumentTypeEnum = DocumentTypeEnum;

  private isSuggestionUpToDate = false;

  get isSuggestDisabled(): boolean {
    return (
      !this.actionPlanExists || this.isProductSuggestionInProgress || this.isSuggestionUpToDate
    );
  }

  private documentService = inject(DocumentService);

  public ngOnInit(): void {
    this.subscribeToDocumentChanges();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['suggestedProducts']) {
      this.isSuggestionUpToDate = this.suggestedProducts !== null;
    }
  }

  public suggestProducts(): void {
    this.documentService.setDocumentChanged(DocumentTypeEnum.ACTION_PLAN, false);
    this.documentService.setOptionalDocumentsChanged(false);
    this.rerun.emit();
  }

  private subscribeToDocumentChanges(): void {
    this.documentService.getDocument(DocumentTypeEnum.ACTION_PLAN).subscribe((file) => {
      this.actionPlanExists = !!file;
    });

    this.documentService.isDocumentChanged(DocumentTypeEnum.ACTION_PLAN).subscribe((changed) => {
      if (changed) {
        this.documentService.setDocumentChanged(DocumentTypeEnum.ACTION_PLAN, false);
        this.suggestedProducts = null;
        this.productSuggestionError = false;
        this.isSuggestionUpToDate = false;
      }
    });

    this.documentService.isOptionalDocumentsChanged().subscribe((changed) => {
      if (changed) {
        this.isSuggestionUpToDate = false;
      }
    });
  }
}
